import { css, cx, etiColors } from '@eti/styles';
import { Text, textVariants } from '@etg/wings';
import type { CartAvailability } from './CartBreakdownRow';

const listStyles = css`
  color: ${etiColors.grayScale[10]};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const airportListItemStyles = css`
  display: flex;
  justify-content: space-between;
`;

const passContainerStyles = css`
  align-items: center;
  display: inline-flex;
  gap: 3px;
  margin-inline-start: 10px;
`;

const passStyles = css`
  margin: 0;
`;

interface CartBreakdownRowAvailabilityProps {
  availability: CartAvailability;
  dataTestId: string;
  className?: string;
}

const CartBreakdownRowAvailability = ({
  availability,
  dataTestId,
  className,
}: CartBreakdownRowAvailabilityProps) => {
  const { airportList, passLabel } = availability;

  return airportList.length > 0 ? (
    <ul className={listStyles} role="list">
      {airportList.map(({ airportName, numberOfPass }, index: number) => (
        <li
          className={cx(airportListItemStyles, className)}
          data-testid={`${dataTestId}-dataRow`}
          key={`subsection-${index}`}
        >
          <Text variant={textVariants._12}>{airportName}</Text>
          <div className={passContainerStyles}>
            <Text className={passStyles} variant={textVariants._12}>
              {numberOfPass}
            </Text>
            <Text className={passStyles} variant={textVariants._12}>
              {passLabel}
            </Text>
          </div>
        </li>
      ))}
    </ul>
  ) : null;
};

export default CartBreakdownRowAvailability;
